import { Body, Column, LoadingEmptyState } from '@alto/design-system';
import * as React from 'react';
import styled from 'styled-components';
import { CommsVerificationFail } from './CommsVerificationFail';
import { CommsVerificationSuccess } from './CommsVerificationSuccess';
import { PageBackground } from '~web/components/Page';
import altoFullNeighborhood from '~web/images/altoFullNeighborhood@2x.png';

type Props = {
  readonly loading: boolean;
  readonly isVerified: boolean | null | undefined;
  readonly commsChannel: string;
  readonly token: string;
  readonly authorized: boolean;
};

const StylePageBackground = styled(PageBackground)`
  width: 100%;
  max-width: none;
  background-color: #fff7f0;
  background-image: url('${altoFullNeighborhood}');
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: bottom;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Loading = () => (
  <Column
    flexGrow={1}
    center
    gap="SM"
  >
    <Body>Verifying...</Body>
    <LoadingEmptyState />
  </Column>
);

export const CommsVerificationStatus = ({ loading, isVerified, commsChannel, token, authorized }: Props) => {
  if (loading)
    return (
      <StylePageBackground>
        <Loading />
      </StylePageBackground>
    );

  if (isVerified) {
    return (
      <StylePageBackground>
        <CommsVerificationSuccess
          commsChannel={commsChannel}
          authorized={authorized}
        />
      </StylePageBackground>
    );
  }

  return (
    <StylePageBackground>
      <CommsVerificationFail
        commsChannel={commsChannel}
        token={token}
        authorized={authorized}
      />
    </StylePageBackground>
  );
};
